<script lang="ts">
	import type { Zoi } from '$lib/components/zoi/types';
	import ZoiMarker from '$lib/components/map/markers/ZoiMarker.svelte';
	import { FillLayer, GeoJSON, LineLayer } from 'svelte-maplibre';

	interface Props {
		zoi: Zoi;
		fillPolygon: boolean;
		onclick: (zoi: Zoi) => void;
		dataTestId: string;
	}

	const { zoi, fillPolygon, onclick, dataTestId }: Props = $props();

	const lineColor = $derived(zoi.isArrivalZoi ? '#FFAD69' : '#27509B');
	const fillColor = $derived(zoi.isArrivalZoi ? '#FFAD6926' : 'rgba(39, 80, 155, 0.25)');
</script>

<GeoJSON data={{ type: 'Polygon', coordinates: zoi.polygon.coordinates }}>
	{#if fillPolygon}
		<FillLayer
			paint={{
				'fill-color': fillColor,
			}}
		/>
	{/if}

	<LineLayer
		layout={{ 'line-cap': 'round', 'line-join': 'round' }}
		paint={{
			'line-width': 2,
			'line-dasharray': [2, 2],
			'line-color': lineColor,
		}}
	/>
</GeoJSON>
{#if !zoi.isArrivalZoi}
	<ZoiMarker {zoi} {onclick} {dataTestId} />
{/if}
